
//import Chart from "./node_modules/chart.js/auto";
//import { Chart } from "chart.js/auto";
import Chart from "chart.js/auto";
//import { Chart } from "chart.js";

//import Store from "./drdocstore.js";
//import { DrDocWeb } from "./drdocweb.js";
import DrDocWeb from "./drdocweb.js";
import DrDoc from "./drdoc.js";
//import "./drdocweb.js";

import 'chartjs-adapter-moment';

//import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';
//Chart.register(MatrixController, MatrixElement);

/*
chartAxis = {
    // gibt die primäre Achse an
    primary: 'x',
    sort: 'x',
    color: 'x',
    tableFieldName: '',
    type: 'logarithmic', 'linear', 'bar', 'line',
    groupLabel1: {
        fieldName: ,
    },
    groupLabel2: {
        fieldName: ,
    },
    groupLabel3: {
        fieldName: ,
    },

    // Achsen: 'x', 'y', 'y2', 'y3', 'y4', 'y5', 'y_alt', 'r'
    x: {
        title: ,
        fieldName: ,
    },
    y: {
        title: ,
        fieldName: '',
        fieldNamesAlt: [ ],
        format: 'number', 'string', 'date'
        stack: true,
        sum: true,
        showMedian: true,
        showMin: true,
        showMax: true,
        type: 'logarithmic', 'linear',
        hideNull: false, // für primary Axis
    },
    r: {
        title: ,
        fieldName: ,
        type: 'linear'
    },
}
*/

//if (window.DrDocChart !== undefined)
//    return;

if (window._chart_auto_resize === undefined)
{
    window._chart_auto_resize = true;
    function beforePrintHandler () {
        for (let id in Chart.instances) {
            Chart.instances[id].resize();
        }
    }
    window.addEventListener('beforeprint', beforePrintHandler);
    window.addEventListener('afterprint', beforePrintHandler);
}


const DrDocChartAxisNameArr = ['x', 'y', 'y2', 'y3', 'y4', 'y5', 'y_alt', 'r', 'r_alt'];

export default function DrDocChart(chartId, chartType, chartTitle, chartAxis, archiveName, searchObj, cookie, log, retAsync, preprocess, selection)
//function DrDocChart(chartId, chartType, chartTitle, chartAxis, archiveName, searchObj, cookie, log, retAsync)
//DrDocWeb.Chart = function(chartId, chartType, chartTitle, chartAxis, archiveName, searchObj, cookie, log, retAsync)
//window.DrDocChart = function(chartId, chartType, chartTitle, chartAxis, archiveName, searchObj, cookie, log, retAsync)
{
    if (Chart.getChart(chartId)) {
        Chart.getChart(chartId).destroy();
    }

    if (log)
        log('Chart.js: before promise');

    //return new Promise(function (resolve, reject) {

    if (chartAxis.primary == undefined)
        chartAxis.primary = 'x';
    if (chartAxis.color == undefined)
        chartAxis.color = 'r';

    if (searchObj == undefined) {
        searchObj = {};
        //searchObj[chartAxis.y.fieldName] = '!0';
        searchObj[chartAxis[chartAxis.primary].fieldName] = '*';
        console.log(JSON.stringify(searchObj));
    }

    let getObj = {
        archive: archiveName,
        action: 'searchfields',
        value: JSON.stringify(searchObj),
        selection: (DrDocWeb.IsNullOrEmpty(selection) ? ';' : (selection + ';')),
        content_tablerows: true,
        target_profile: true,
        max: -1,
        start: 0,
        count: 10000
    };

    var addFieldSelection = function (fn) {
        if (!DrDocWeb.IsNullOrEmpty(fn) && getObj.selection.indexOf(';' + fn + ';') == -1)
            getObj.selection += fn + ';';
    };

    // forEachAxisName(function(axisName) { });
    var hasAxisName = function (axisName) {
        if (DrDocWeb.IsNullOrEmpty(axisName))
            return false;
        return chartAxis[axisName] !== undefined && chartAxis[axisName] !== null && !DrDocWeb.IsNullOrEmpty(chartAxis[axisName].fieldName);
    }
    var forEachAxisName = function (fn) {
        for (let i = DrDocChartAxisNameArr.length - 1; i >= 0; i--) {
            // Falls eine Achse nicht in Config enthalten ist, diese Achse entfernen
            let axisName = DrDocChartAxisNameArr[i];
            if (!hasAxisName(axisName)) {
                //DrDocChartAxisNameArr[i] = undefined;
                //delete DrDocChartAxisNameArr[i];
                continue;
            }

            fn(axisName);
        }
    };

    addFieldSelection(chartAxis.tableFieldName);

    // Achse initialisieren
    forEachAxisName(function (axisName) {
        
        // fieldNames enthält alle Feldnamen
        chartAxis[axisName].fieldNames = [ ];
        chartAxis[axisName].fieldNames.push(chartAxis[axisName].fieldName);
        if (chartAxis[axisName].fieldNamesAlt != undefined)
        {
            for (let fieldName of chartAxis[axisName].fieldNamesAlt)
            {
                chartAxis[axisName].fieldNames.push(fieldName);
                // Feldauswahl für Werte
                addFieldSelection(fieldName);
            }
        }

        // Feldauswahl für Werte
        addFieldSelection(chartAxis[axisName].fieldName);

        chartAxis[axisName].max = 0.0;
        chartAxis[axisName].min = 0.0;
        if (DrDocWeb.IsNullOrEmpty(chartAxis[axisName].stack))
            chartAxis[axisName].stack = false;

    });
    // Feldauswahl für Label
    for (let group_i = 1; group_i <= 5; group_i++) {
        if (chartAxis['groupLabel' + group_i] == undefined || DrDocWeb.IsNullOrEmpty(chartAxis['groupLabel' + group_i].fieldName))
            continue;
        //if (hasAxisName(chartAxis.groupLabel1.fieldName))
        addFieldSelection(chartAxis['groupLabel' + group_i].fieldName);
    }

    //getObj.selection += ';' + chartAxis[chartAxis.primary].fieldName;
    if (hasAxisName(chartAxis.primary))
        addFieldSelection(chartAxis[chartAxis.primary].fieldName);
    getObj.selection = getObj.selection.trim(';');

    //DrDocWeb.ServerHost = 'http://192.168.200.38';
    //DrDocWeb.ServerPort = 8080;

    const getDataUrl = '/model/crud';

    if (log)
        log('Chart.js: Request URL: ' + DrDocWeb.GetRequestUrl(getDataUrl, getObj));

    /*let promiseReq = DrDocWeb.Send('GET', getDataUrl, getObj, undefined, 'json', '', cookie);
    
    if (log)
    log('Chart.js: proc resp 1');

    // promiseReq ende
    promiseReq.catch(function(err){
        if (log)
          log('Chart.js: ERROR  DrDocWeb.Send: ' + err);
    });
    return promiseReq.then(function (data) {*/

    var processResponse = function (data) {
        console.log('response data', data);
        if (log)
            log('Chart.js: proc resp 2');

        var chart_data =
        {
            labels: [],
            datasets: [],
        };

        if (data.Result == undefined || data.Result == null || data.Result.length == 0) {
            if (log)
                log('Chart.js: response data: 0');
            //reject(new Error('Keine Suchergebnisse vorhanden.'));
            return;
        }
        if (log)
            log('Chart.js: response data: OK');

        // leere Elemente entfernen
        for (var i = data.Result.length - 1; i >= 0; i--) {
            var itm = data.Result[i];
            
            // für jede Achse/Feld die alternativen Feldwerte laden
            forEachAxisName(function (axisName) {
                // alle alternativen Feldnamen durchlaufen, bis ein gefüllter Wert für die Achse vorhanden ist.
                for (let fieldName of chartAxis[axisName].fieldNames)
                {
                    if (DrDocWeb.IsNullOrEmpty(itm[fieldName]))
                        continue;
                    
                    if (chartAxis[axisName].fieldName != fieldName)
                        itm[chartAxis[axisName].fieldName] = itm[fieldName];
                    break;
                }
            });

            // Leere Datensätze aus Liste entfernen, wenn Primary Axis fieldName keinen Wert hat
            if (hasAxisName(chartAxis.primary) && DrDocWeb.IsNullOrEmpty(itm[chartAxis[chartAxis.primary].fieldName])) {
                if (chartAxis.hideNull === true) {
                    // leeres Element entfernen
                    data.Result.splice(i, 1);
                }
                else {
                    // leeres Element umbenennen
                    itm[chartAxis[chartAxis.primary].fieldName] = 'ERROR';
                    //itm[chartAxis[chartAxis.primary].fieldName] = null;

                    if (DrDocWeb.IsNullOrEmpty(chartAxis[chartAxis.primary].format)) {
                        chartAxis[chartAxis.primary].format = 'number';
                        itm[chartAxis[chartAxis.primary].fieldName] = null;
                    }

                }
            }
        }

        // Daten parsen
        data.Result.forEach(function (itm) {

            for (let group_i = 1; group_i <= 5; group_i++) {
                if (chartAxis['groupLabel' + group_i] == undefined || DrDocWeb.IsNullOrEmpty(chartAxis['groupLabel' + group_i].fieldName))
                    continue;
                if (DrDocWeb.IsNullOrEmpty(itm[chartAxis['groupLabel' + group_i].fieldName]))
                    itm[chartAxis['groupLabel' + group_i].fieldName] = 'parse LEER ' + chartAxis['groupLabel' + group_i].fieldName;
            }
            //itm[chartAxis.y.fieldName] = isNaN(parseInt(itm[chartAxis.y.fieldName])) ? itm[chartAxis.y.fieldName] : parseInt(itm[chartAxis.y.fieldName]);


            forEachAxisName(function (axisName) {
                if (chartAxis[axisName] === undefined) {
                    console.warn('Axis undefined!', axisName);
                    return;
                }
                //itm[chartAxis[axisName].fieldName
                if (chartAxis[axisName].format == 'string') {
                    if (DrDocWeb.IsNullOrEmpty(itm[chartAxis[axisName].fieldName]))
                        itm[chartAxis[axisName].fieldName] = null;
                }
                else if (chartAxis[axisName].format == 'date' || chartAxis[axisName].format == 'ttm') {
                    // toDateString();
                    itm[chartAxis[axisName].fieldName] = DrDocWeb.ToIsoDateTimeStr(itm[chartAxis[axisName].fieldName]);
                    //itm[chartAxis[axisName].fieldName] = DrDocWeb.ParseDateTime(itm[chartAxis[axisName].fieldName]);
                }
                else //if (chartAxis[axisName].format == 'number')
                {
                    chartAxis[axisName].format = 'number';

                    // Maximalwet auslesen
                    // "max" Wert für Radar setzen wg. Normierung
                    if (itm[chartAxis[axisName].fieldName] !== undefined && itm[chartAxis[axisName].fieldName] !== null && !isNaN(parseFloat(itm[chartAxis[axisName].fieldName]))) // && itm[chartAxis[axisName].fieldName].indexOf(' ') === -1)
                    {
                        itm[chartAxis[axisName].fieldName] = parseFloat(itm[chartAxis[axisName].fieldName]);
                    }
                    else {
                        //itm[chartAxis[axisName].fieldName] = 0;
                        itm[chartAxis[axisName].fieldName] = null;
                        //console.warn('parse empty val', axisName, itm);
                    }
                }
                /*else
                {
                    //console.warn('Bad Axis Format!', axisName, chartAxis[axisName].format);
                }*/
            });
        });

        /*function getItemLabel1(itm) {
            return itm[chartAxis.groupLabel1.fieldName];
            //return itm[chartAxis.groupLabel1.fieldName] + ' / ' + itm['dateY'];
        };
        function getItemLabel2(itm) {
            return itm[chartAxis.groupLabel2.fieldName];
        };*/
        function getItemLabel(itm) {
            let ret = '';
            for (let group_i = 1; group_i <= 5; group_i++) {
                if (chartAxis['groupLabel' + group_i] == undefined || DrDocWeb.IsNullOrEmpty(chartAxis['groupLabel' + group_i].fieldName))
                    continue;
                if (group_i > 1)
                    ret += ' | ';
                ret += itm[chartAxis['groupLabel' + group_i].fieldName];
            }
            return ret;
        };
        function getItemLabelXAxis(itm) {
            if (chartAxis.x !== undefined && !DrDocWeb.IsNullOrEmpty(chartAxis.x.fieldName) && !DrDocWeb.IsNullOrEmpty(itm[chartAxis.x.fieldName]))
                return itm[chartAxis.x.fieldName];

            //console.warn ('getItemLabelXAxis X-LEER', itm);
            return 0; //'getItemLabelXAxis X-LEER ' + getItemLabel1(itm);
            //return undefined;
        };
        /*function getItemYAxis(itm) {
            if (chartAxis.y !== undefined && !DrDocWeb.IsNullOrEmpty(chartAxis.y.fieldName) && !DrDocWeb.IsNullOrEmpty(itm[chartAxis.y.fieldName]))
                return itm[chartAxis.y.fieldName];

            //return 0;
            return getItemLabelXAxis(itm);
        };*/

        function sortByValueByFieldName(fieldName) {
            return function (itm_a, itm_b) {

                //return itm_a[chartAxis.y.fieldName].localeCompare(itm_b[chartAxis.y.fieldName]);

                if (DrDocWeb.IsNullOrEmpty(fieldName))
                    return 0;

                let a = 0;
                let b = 0;
                let cmp = 0;

                a = itm_a[fieldName];
                b = itm_b[fieldName];

                if (a === null || a === undefined)
                    a = 0.0;
                if (b === null || b === undefined)
                    b = 0.0;
                if (typeof a === 'string') {
                    cmp = a.localeCompare(b);
                    if (cmp != 0)
                        return cmp;
                }
                else if (typeof a === 'number' || typeof a === 'date') {
                    if (a > b)
                        return 1;
                    if (a < b)
                        return -1;
                }
                else {
                    console.warn('bad type cmp', a, b);
                }

                return 0;
            };
        };

        function sortByValue(axisName) {
            if (DrDocWeb.IsNullOrEmpty(axisName))
                return null;
            if (DrDocWeb.IsNullOrEmpty(chartAxis[axisName]))
                return null;
            if (DrDocWeb.IsNullOrEmpty(chartAxis[axisName].fieldName))
                return null;

            return sortByValueByFieldName(chartAxis[axisName].fieldName);
        };

        // Daten sortieren
        data.sort = function(sortAxisName)
        {
            if (DrDocWeb.IsNullOrEmpty(sortAxisName))
                sortAxisName = chartAxis.sort;
            if (DrDocWeb.IsNullOrEmpty(chartAxis.primary))
                sortAxisName = chartAxis.primary;
            if (!DrDocWeb.IsNullOrEmpty(sortAxisName) && hasAxisName(sortAxisName)) {
                let sortFn = sortByValue(sortAxisName);
                if (sortFn) {
                    data.Result.sort(sortFn);
                    //console.log('sorted data sort ', chartAxis.sort, ': ', data.Result);
                }
            }
        };

        if (preprocess !== undefined && preprocess !== null)
        {
            preprocess(data);
        }

        data.sort();

        /*else if (!DrDocWeb.IsNullOrEmpty(chartAxis.primary) && hasAxisName(chartAxis.primary))
        {
            data.Result.sort(sortByValue(chartAxis.primary));
            //console.log('Axis "R" not found: ', chartAxis);
            console.log('sorted data primary ', chartAxis.primary, ': ', data.Result);
        }*/
        //console.log('Primary: ', chartAxis.primary);

        // --
        // Farben laden

        let chartColorsFg = []; // [ 'rgb(128,0,0)', 'rgb(0,128,0)', 'rgb(0,0,128)', 'rgb(0,128,128)', 'rgb(128,0,128)' ];
        let chartColorsBg = []; // [ 'rgba(128,0,0, 0.3)', 'rgba(0,128,0, 0.3)', 'rgba(0,0,128, 0.3)', 'rgba(0,128,128, 0.3)', 'rgba(128,0,128, 0.3)' ];
        let groupCount = 0;
        let chartColorArr = [
            128,
            128 + 64,
            128 - 64,
            128 + 64 + 32,
            128 - 64 - 32,
            128 + 32,
            128 - 32,
            250,
        ];
        chartColorArr.forEach(function (colorNum) {
            chartColorsFg.push(`rgb(${colorNum}, 0, 0)`);
            chartColorsFg.push(`rgb(0, ${colorNum}, 0)`);
            chartColorsFg.push(`rgb(0, 0, ${colorNum})`);
            chartColorsFg.push(`rgb(${colorNum}, 0, ${colorNum})`);
            chartColorsFg.push(`rgb(${colorNum}, ${colorNum}, 0)`);
            chartColorsFg.push(`rgb(0, ${colorNum}, ${colorNum})`);
            //});
            //chartColorArr.forEach(function(colorNum) {
            chartColorsBg.push(`rgba(${colorNum}, 0, 0, 0.33)`);
            chartColorsBg.push(`rgba(0, ${colorNum}, 0, 0.33)`);
            chartColorsBg.push(`rgba(0, 0, ${colorNum}, 0.33)`);
            chartColorsBg.push(`rgba(${colorNum}, 0, ${colorNum}, 0.33)`);
            chartColorsBg.push(`rgba(${colorNum}, ${colorNum}, 0, 0.33)`);
            chartColorsBg.push(`rgba(0, ${colorNum}, ${colorNum}, 0.33)`);
        });
        chartColorArr.forEach(function (colorNum) {
            // grau
            chartColorsFg.push(`rgb(${colorNum}, ${colorNum}, ${colorNum})`);
            chartColorsBg.push(`rgba(${colorNum}, ${colorNum}, ${colorNum}, 0.33)`);
        });
        // console.log('colors', chartColorsFg, chartColorsBg);

        // --

        // Für TTM Trailing twelve months, yoy year on year:
        // Y = Summe der letzten 12 Monate
        const axisName_x = 'x';
        if (chartAxis[axisName_x] !== undefined && chartAxis[axisName_x].format == 'ttm' && !DrDocWeb.IsNullOrEmpty(chartAxis[axisName_x].fieldName)) {
            let fieldName_x = chartAxis[axisName_x].fieldName;
            let stack = data.Result;

            // X-Achse ist vom Typ Datum und TTM

            //let axisName_y = 'y';
            forEachAxisName(function (axisName_y) {
                if (chartAxis[axisName_y].format == 'number' && !DrDocWeb.IsNullOrEmpty(chartAxis[axisName_y].fieldName)) {
                    let fieldName_y = chartAxis[axisName_y].fieldName;
                    let fieldName_y_ttm_tmp = fieldName_y + '_ttm_' + DrDocWeb.Random(8);

                    //chartAxis[axisName_y].sum = false;
                    //chartAxis[axisName_y].stack = false;

                    //for (let stack_i = stack.length - 1; stack_i >= 0; stack_i--) {
                    //    let dataset_itm = stack[stack_i];
                    for (let dataset_itm of stack) {
                        // TTM Property mit Wert "0" initialisieren
                        let dataset_itm_y = 0.0;

                        let dataset_itm_x = dataset_itm[fieldName_x];

                        let dataset_itm_x_max = DrDocWeb.ParseDateTime(dataset_itm_x);
                        //DrDocWeb.DateTimeAdd(dataset_itm_x_max, -1, 'day');

                        let dataset_itm_x_min = DrDocWeb.ParseDateTime(dataset_itm_x);
                        //DrDocWeb.DateTimeAdd(dataset_itm_x_min, -3, 'day');
                        DrDocWeb.DateTimeAdd(dataset_itm_x_min, -1, 'year');

                        for (let dataset_itm_tmp of stack) {
                            // Doppelte Datensätze ignorieren
                            //if (dataset_itm[DrDoc.ID_FIELD] === dataset_itm_tmp[DrDoc.ID_FIELD])
                            //    continue;

                            // ist "dataset_itm" im Bereich?
                            let dataset_itm_tmp_x = dataset_itm_tmp[fieldName_x];
                            let dataset_itm_tmp_y = dataset_itm_tmp[fieldName_y];
                            let dataset_itm_tmp_x_dateTime = DrDocWeb.ParseDateTime(dataset_itm_tmp_x);

                            if (dataset_itm_x === dataset_itm_tmp_x || (dataset_itm_tmp_x_dateTime <= dataset_itm_x_max && dataset_itm_tmp_x_dateTime > dataset_itm_x_min)) {
                                //console.log('Chart TTM: ', DrDocWeb.ToIsoDateTimeStr(dataset_itm_x_min).substring(0,10), ' < ', DrDocWeb.ToIsoDateTimeStr(dataset_itm_tmp_x_dateTime).substring(0,10), ' < ', DrDocWeb.ToIsoDateTimeStr(dataset_itm_x_max).substring(0,10));

                                dataset_itm_y += dataset_itm_tmp_y;
                            }
                        }

                        dataset_itm[fieldName_y_ttm_tmp] = dataset_itm_y;
                    }

                    // TTM Property setzen und Temp wieder löschen
                    for (let dataset_itm of stack) {
                        dataset_itm[fieldName_y] = dataset_itm[fieldName_y_ttm_tmp];
                        delete dataset_itm[fieldName_y_ttm_tmp];
                    }
                }
            });
        }


        // Saldo Felder erstellen
        if (chartAxis[axisName_x] !== undefined && chartAxis[axisName_x].format == 'date' && !DrDocWeb.IsNullOrEmpty(chartAxis[axisName_x].fieldName)) {
            let fieldName_x = chartAxis[axisName_x].fieldName;
            let stack = data.Result;

            // X-Achse ist vom Typ Datum und Y als Saldo aufsummieren

            //let axisName_y = 'y';
            forEachAxisName(function (axisName_y) {
                if (chartAxis[axisName_y].format == 'number' && !DrDocWeb.IsNullOrEmpty(chartAxis[axisName_y].fieldName)) {
                    let fieldName_y = chartAxis[axisName_y].fieldName;
                    let fieldName_y_tmp = fieldName_y + '_saldo_' + DrDocWeb.Random(8);
                    
                    for (let dataset_itm of stack) {
                        // mit Wert "0" initialisieren
                        let dataset_itm_y = 0.0;

                        let dataset_itm_x = dataset_itm[fieldName_x];
                        let dataset_itm_x_max = DrDocWeb.ParseDateTime(dataset_itm_x);

                        for (let dataset_itm_tmp of stack) {

                            // ist "dataset_itm" im Bereich?
                            let dataset_itm_tmp_x = dataset_itm_tmp[fieldName_x];
                            let dataset_itm_tmp_y = dataset_itm_tmp[fieldName_y];
                            let dataset_itm_tmp_x_dateTime = DrDocWeb.ParseDateTime(dataset_itm_tmp_x);
                            
                            // von Start bis jetzt
                            if (dataset_itm_x === dataset_itm_tmp_x || (dataset_itm_tmp_x_dateTime <= dataset_itm_x_max))
                                dataset_itm_y += dataset_itm_tmp_y;
                        }

                        dataset_itm[fieldName_y_tmp] = dataset_itm_y;
                    }

                    // TTM Property setzen und Temp wieder löschen
                    for (let dataset_itm of stack) {
                        dataset_itm[fieldName_y + '--saldo'] = dataset_itm[fieldName_y_tmp];
                        delete dataset_itm[fieldName_y_tmp];
                    }
                }
            });
        }
        

        // min/Max Value lesen, für Bubble-Chart Radius
        forEachAxisName(function (axisName) {
            chartAxis[axisName].max = 0.0;
            chartAxis[axisName].min = 0.0;
        });
        data.Result.forEach(function (itm) {
            forEachAxisName(function (axisName) {
                if (chartAxis[axisName].format == 'number')
                {
                    // Maximalwet auslesen
                    let val = DrDocWeb.ParseInt(itm[chartAxis[axisName].fieldName]);
                    if (val !== 0)
                    {
                        chartAxis[axisName].max = Math.max(val, chartAxis[axisName].max);
                        chartAxis[axisName].min = Math.min(val, chartAxis[axisName].max);
                        //console.log('min/max: ', axisName, ' / ', chartAxis[axisName].min, ' <-> ', chartAxis[axisName].max);
                    }
                }
            });
        });



        // Daten Gruppieren
        // Nach X-Werten gruppieren und X-Achse füllen
        let groupObjX = DrDocWeb.DataGroup(data.Result, [
            getItemLabelXAxis
        ]);
        console.log('groupObjX data', groupObjX);
        chart_data.labels = DrDocWeb.ObjGetKeys(groupObjX);

        // Nach Label (Gruppe 1, 2, 3) + X-Achse gruppieren
        let groupObjLabel = DrDocWeb.DataGroup(data.Result, [
            getItemLabel,
            getItemLabelXAxis
            //getItemYAxis
        ]);
        console.log('groupObjLabel data', groupObjLabel);
        for (let label in groupObjLabel) {
            if (label === undefined) {
                console.warn('nullll', label);
            }

            let ds_IDs = [];
            let ds_colors = [];
            // axisName -> values[]
            let ds_sum = {};
            let ds_sum_arr = {};
            let ds_sum_detail_arr = {};
            let ds_data = {};

            forEachAxisName(function (axisName) {
                ds_sum[axisName] = 0.0;
                ds_sum_arr[axisName] = [];
                ds_data[axisName] = [];

                ds_sum_detail_arr[axisName] = {};
            });

            let label_datasets = groupObjLabel[label];

            for (let xAxisValue in groupObjX) {
                forEachAxisName(function (axisName) {
                    ds_sum_detail_arr[axisName][xAxisValue] = [];
                });

                var stack = null;
                // wenn "stackID" gesetzt ist, alle Datensätze anzeigen
                //if (!DrDocWeb.IsNullOrEmpty(chartAxis[axisName].stackID))
                //    stack = groupObjX[xAxisValue];
                //else
                stack = label_datasets[xAxisValue];

                // Daten sortieren
                /*if (!DrDocWeb.IsNullOrEmpty(chartAxis.sort) && hasAxisName(chartAxis.sort) && stack != undefined) {
                    stack.sort(sortByValue(chartAxis.sort));
                    console.log('sorted data ', chartAxis.sort, ': ', stack);
                }*/

                // Wenn es ein Radar Chart ist, die Daten als Array und nicht als Objekt ausgeben
                if (chartType === 'radar' || chartType === 'doughnut' || chartType === 'pie') {
                    if (stack === undefined) {
                        // Mit "0" auffüllen, damit Daten an den N-ten Index rutschen
                        forEachAxisName(function (axisName) {
                            //if (0 > 0)
                            //ds_sum_arr2[axisName].push(0);
                            ds_data[axisName].push(null);
                        });

                        ds_colors.push(`rgba(128,128,128, 0.2)`);
                        ds_IDs.push('0');
                    }
                    else {

                        // Nach-Werten sortieren
                        //stack.sort(sortByValue('y'));
                        //console.log('Group sorted by y / Label: ', label, ' -> ', xAxisValue, ' / by y: ', stack);

                        // Alle Werte der Achse summieren und IDs merken
                        //let dataset_itm_id_sum = '';
                        let dataset_itm_y_value_sum = {};

                        forEachAxisName(function (axisName) {
                            dataset_itm_y_value_sum[axisName] = 0.0;
                        });

                        for (let stack_i in stack) {
                            var dataset_itm = stack[stack_i];

                            forEachAxisName(function (axisName) {
                                let dataset_itm_y_value = dataset_itm[chartAxis[axisName].fieldName];
                                if (chartAxis[axisName].format == 'number') {
                                    dataset_itm_y_value_sum[axisName] += dataset_itm_y_value;

                                    if (dataset_itm_y_value != null) // > 0)
                                        ds_sum_arr[axisName].push(dataset_itm_y_value);
                                }
                                if (dataset_itm_y_value != null) // > 0)
                                    ds_sum_detail_arr[axisName][xAxisValue].push(dataset_itm_y_value);
                            });

                            //dataset_itm_id_sum += dataset_itm[DrDoc.ID_FIELD] + '|';
                            ds_IDs.push(dataset_itm[DrDoc.ID_FIELD]);
                        }

                        forEachAxisName(function (axisName) {
                            let dataset_itm_y_value = dataset_itm_y_value_sum[axisName];
                            ds_sum[axisName] += dataset_itm_y_value;
                            //if (dataset_itm_y_value != null)
                            //    ds_sum_arr[axisName].push(dataset_itm_y_value);
                            ds_data[axisName].push(dataset_itm_y_value);
                        });



                        //let r_color = Math.round(50 + Math.abs(dataset_itm_r_value_sum) / chartAxis[chartAxis.color].max * 165);
                        //r_color = isNaN(r_color) ? 128 : r_color;
                        //ds_colors.push(dataset_itm_r_value_sum < 0.0 ? `rgba(${r_color}, 0, 0, 0.2)` : `rgba(0, ${r_color}, 0, 0.2)`);

                        //ds_IDs.push(dataset_itm_id_sum.trim('|'));
                    }

                }
                else {
                    // => kein Radar Chart

                    // Nach-Werten sortieren
                    //stack.sort(sortByValue('y'));
                    //console.log('Group sorted by y / Label: ', label, ' -> ', xAxisValue, ' / by y: ', stack);

                    for (let stack_i in stack) {
                        let dataset_itm = stack[stack_i];
                        //let dataset_itm_x_value = dataset_itm[chartAxis.x.fieldName];

                        // Für Bubble Charts die Größe der Blasen setzen durch normieren vom Achse "r"
                        let dataset_itm_r_value_pixel = 10;
                        if (chartAxis.r !== undefined && chartAxis.r !== null && chartAxis.r.format == 'number') {
                            let dataset_itm_r_value = chartAxis.r !== undefined ? dataset_itm[chartAxis.r.fieldName] : 0;
                            dataset_itm_r_value_pixel = 1 + Math.abs(dataset_itm_r_value) / (Math.abs(chartAxis.r.max) + Math.abs(chartAxis.r.min)) * 46.0;
                            if (isNaN(dataset_itm_r_value_pixel))
                                dataset_itm_r_value_pixel = 0;
                        }

                        ds_IDs.push(dataset_itm[DrDoc.ID_FIELD]);

                        forEachAxisName(function (axisName) {
                            let dataset_itm_y_value = dataset_itm[chartAxis[axisName].fieldName];
                            //if ((xAxisValue == 'ERROR' || (dataset_itm_y_value == undefined || dataset_itm_y_value == null)) && chartAxis[axisName].hideNull === true)
                            //    return;
                            if (chartAxis[axisName].format == 'number') {
                                ds_sum[axisName] += dataset_itm_y_value;
                                //ds_sum2[axisName][xAxisValue] += dataset_itm_y_value;
                                if (dataset_itm_y_value != null) // > 0)
                                    ds_sum_arr[axisName].push(dataset_itm_y_value);
                            }

                            let itm_i = (chartAxis[axisName].sum === true) ? DrDocWeb.GetArrayItemIndexWhere(ds_data[axisName], function (itm) { return itm.x == xAxisValue; }) : -1;
                            if (itm_i >= 0) {
                                if (chartAxis[axisName].format == 'number') {
                                    ds_data[axisName][itm_i].y += dataset_itm_y_value;
                                }
                                ds_data[axisName][itm_i]._ids.push(dataset_itm[DrDoc.ID_FIELD]);
                            }
                            else {
                                ds_data[axisName].push({
                                    //stack: label + '--' + axisName + '--' + (+xAxisValue < 10 ? '0' + xAxisValue : xAxisValue),
                                    stack: label + '--' + axisName + '--' + xAxisValue,
                                    x: xAxisValue,
                                    y: dataset_itm_y_value,
                                    r: dataset_itm_r_value_pixel,
                                    pointRadius: dataset_itm_r_value_pixel,
                                    pointHoverRadius: dataset_itm_r_value_pixel + 2,
                                    _ids: [dataset_itm[DrDoc.ID_FIELD]],
                                });
                            }

                            if (dataset_itm_y_value != null) // > 0)
                                ds_sum_detail_arr[axisName][xAxisValue].push(dataset_itm_y_value);
                        });
                    }
                }
            } // Ende for (let xAxisValue in groupObjX)


            /*for (let xAxisValue in groupObjX) {

            }*/

            // Datensatz-Group erzeugen / eines je Label bzw. Stack
            forEachAxisName(function (axisName) {
                /*
                // Datensätze nach X-Achsen-Wert sortieren
                ds_data[axisName].sort(function (itm_a, itm_b) {
                    return itm_a.stack.localeCompare(itm_b.stack);
                });
                */

                if (axisName.substring(0, 1) === 'y') {
                    //if (chartAxis[axisName] !== undefined && ds_data[axisName].length > 0) {

                    // Datensatz Label erzeugen
                    let ds_label = '';
                    ds_label += label
                    ds_label += ' - ';
                    //ds_label += 'x = ' + xAxisValue;
                    ds_label += chartAxis[axisName].title;

                    // Median etc berechnen
                    if (chartAxis[axisName].format == 'number') {
                        let ds_label_math = '';
                        if (chartAxis[axisName].sum === true)
                            ds_label_math += 'Summe: ' + ds_sum[axisName].toLocaleString('de-DE', { minimumFractionDigits: 2 }) + '; ';
                        if (chartAxis[axisName].showMedian === true) // chartAxis[axisName].showMedian == undefined || 
                            ds_label_math += 'Median: ' + DrDocWeb.Math_Median(ds_sum_arr[axisName]).toLocaleString('de-DE', { minimumFractionDigits: 1 }) + '; ';
                        if (chartAxis[axisName].showMin === true)
                            ds_label_math += 'Min: ' + chartAxis[axisName].min.toLocaleString('de-DE', { minimumFractionDigits: 2 }) + '; ';
                        if (chartAxis[axisName].showMax === true)
                            ds_label_math += 'Max: ' + chartAxis[axisName].max.toLocaleString('de-DE', { minimumFractionDigits: 2 }) + '; ';

                        if (Object.keys(ds_sum_detail_arr[axisName]).length <= 10 && chartAxis[axisName].showMedian === true) {
                            ds_label_math = ds_label_math.trim();
                            ds_label_math += ' ';

                            for (var xAxisValue in ds_sum_detail_arr[axisName]) {
                                if (ds_sum_detail_arr[axisName][xAxisValue] > 0)
                                    ds_label_math += ';  Median "' + xAxisValue + '": ' + DrDocWeb.Math_Median(ds_sum_detail_arr[axisName][xAxisValue]).toLocaleString('de-DE', { minimumFractionDigits: 1 });
                            }
                        }
                        
                        if (!DrDocWeb.IsNullOrEmpty(ds_label_math))
                        {
                            ds_label += '(' + ds_label_math.trim() + ')';
                        }
                    }


                    /*
                    let ds_label = [];
                    ds_label.push(label);
                    ds_label.push(chartAxis[axisName].title);
                    if (chartAxis[axisName].sum === true)
                        ds_label.push('Summe: ' + ds_sum[axisName].toLocaleString('de-DE', { minimumFractionDigits: 2 }));
                    ds_label.push('Median: ' + DrDocWeb.Math_Median(ds_sum_arr[axisName]).toLocaleString('de-DE', { minimumFractionDigits: 1 }));
                    
                    for (var xAxisValue in ds_sum_detail_arr[axisName])
                    {
                        ds_label.push(
                            //'Median von "' + xAxisValue + '": ' +
                            'Med.:"' + xAxisValue + '": ' +
                            DrDocWeb.Math_Median(ds_sum_detail_arr[axisName][xAxisValue]).toLocaleString('de-DE', { minimumFractionDigits: 1 }));
                    }
                    */

                    //console.log('ds_sum_arr[axisName]', ds_label, chartAxis[axisName].title, '(', axisName, ')', ds_sum_arr, ds_sum_detail_arr[axisName]);

                    let stackID = !DrDocWeb.IsNullOrEmpty(chartAxis[axisName].stackID) ? chartAxis[axisName].stackID : (label + '--' + axisName + '--' + groupCount);
                    let ds_i_found = -1;
                    for (let ds_i in chart_data.datasets) {
                        if (chart_data.datasets[ds_i].stack == stackID)
                        {
                            ds_i_found = ds_i;
                        }
                    }

                    if (ds_i_found >= 0)
                    {
                        chart_data.datasets[ds_i_found].data.push(ds_data[axisName]);
                    }
                    else
                    {
                        // Datensätze eines Labels anfügen
                        chart_data.datasets.push({
                            type: chartAxis[axisName].type !== undefined ? chartAxis[axisName].type : chartType, //'line',
                            xAxisID: 'x',
                            yAxisID: (axisName === 'y_alt' || chartAxis[axisName].alt === true) ? 'y_alt' : 'y',
                            //yAxisID: 'y3',
                            //label: (!DrDocWeb.IsNullOrEmpty(chartAxis[axisName].stackID) ? chartAxis[axisName].stackID : ds_label),
                            label: ds_label,
                            data: ds_data[axisName],
                            _ids: ds_IDs,
                            stack: stackID,

                            //color: chartColorsFg[groupCount],
                            borderColor: (!DrDocWeb.IsNullOrEmpty(chartAxis[axisName].color) ? chartAxis[axisName].color : chartColorsBg[groupCount]),
                            backgroundColor: (!DrDocWeb.IsNullOrEmpty(chartAxis[axisName].color) ? chartAxis[axisName].color : chartColorsBg[groupCount]),

                            fill: false,
                        });

                        if (DrDocWeb.IsNullOrEmpty(chartAxis[axisName].color)) // || DrDocWeb.IsNullOrEmpty(chartAxis[axisName].bgColor))
                            groupCount++;
                    }
                    //}
                }
            });

            //console.log(label, ' => ', label_datasets);
        }
        console.log('chart data', chart_data);

        // xAxisDatasets

        const ctx = document.getElementById(chartId).getContext('2d');

        const config = {
            type: chartType,
            data: chart_data,
            plugins: [],
            events: ['click'],
            options: {
                // Boolean - whether or not the chart should be responsive and resize when the browser does.
                responsive: true,

                // Boolean - whether to maintain the starting aspect ratio or not when responsive, if set to false, will take up entire container
                maintainAspectRatio: false,

                plugins: {
                    legend: {
                        position: 'top',
                    },
                    title: {
                        display: true,
                        text: chartTitle
                    },
                    decimation: {
                        enabled: true,
                        algorithm: 'min-max',
                    },
                },
                // https://www.chartjs.org/docs/latest/configuration/interactions.html
                interaction: {
                    //mode: 'index',
                    mode: 'point',
                    //mode: 'x',
                    //mode: 'nearest',
                    //mode: 'new mode',
                    intersect: true,
                    axis: 'x'
                },
                //stacked: false,
                // indexAxis: chartAxis.primary,
                hover: {
                    //mode: 'x',
                    //mode: 'new mode',
                    //mode: 'nearest',
                },
                scales: {
                },
                parsing: {
                    /*rAxisKey: chartAxis.r.fieldName,
                    xAxisKey: chartAxis.x.fieldName,
                    yAxisKey: chartAxis.y.fieldName,*/

                    rAxisKey: 'r',
                    xAxisKey: 'x',
                    yAxisKey: 'y',

                },

                /*tooltips: {
                    callbacks: {
                      footer: (tooltipItems, data) => {
                          console.log('Tooltip', tooltipItems, data);
                        let total = tooltipItems.reduce((a, e) => a + parseInt(e.yLabel), 0);
                        return 'Total: ' + total;
                      }
                    }
                  },*/

                onClick: function (e, item) {

                    //console.log('onClick 1', e, item, item.length);
                    let item_i = item.length - 1;

                    if (item[item_i] == undefined)
                        console.warn('item[item_i] == undefined', item);

                    if (item[item_i] != undefined && item[item_i].datasetIndex == undefined)
                        console.warn('item[item_i].datasetIndex == undefined', item, item_i, item[item_i]);

                    if (chart_data.datasets == undefined)
                        console.warn('chart_data.datasets == undefined', chart_data);

                    // Datenreihe pro Label
                    let dataset = chart_data.datasets[item[item_i].datasetIndex]; //.data[item[0].index];
                    // Datensatz
                    let dataset_sub = dataset.data[item[item_i].index];

                    //console.log('onClick 2', dataset, dataset_sub);
                    /*
                    let id = dataset._ids[item[item_i].index];
                    let valueObj = dataset.data[item[item_i].index];
                    console.log(`Item with text ${item[item_i].index} and index ${item[item_i].datasetIndex} clicked`);
                    console.log('onclick', id, valueObj['ref_num'], valueObj, dataset);
                    DrDoc.GetDataset(null, archiveName, '', id, 'get');
                    */
                    console.log(`Item with text index "${item[item_i].index}" and datasetIndex "${item[item_i].datasetIndex}" clicked`);

                    let idArr = null;
                    if (dataset_sub._ids != undefined && dataset_sub._ids != null && dataset_sub._ids.length > 0) {
                        // dataset.data ist eine Array von Objekten z.B. für Bar
                        idArr = dataset_sub._ids;
                    }
                    else {
                        // dataset.data ist eine Array von Zahlen z.B. für Radar
                        idArr = [dataset._ids[item[item_i].index]];
                        //idArr = dataset._ids;
                    }

                    let searchFieldsObj = {};
                    searchFieldsObj[DrDoc.ID_FIELD] = idArr.join('|');

                    console.log('onclick idArr', idArr);
                    console.log('onclick ds', dataset, dataset._ids);
                    console.log('onclick ds-sub', dataset_sub, dataset_sub._ids);

                    //DrDoc.SearchFields(null, archiveName, searchFieldsObj);
                    //DrDoc.SearchFields(document.documentElement, archiveName, searchFieldsObj);
                    DrDoc.SearchFieldsInfo(null, archiveName, searchFieldsObj);
                },

            },
        };

        // Achsen etc. formattieren
        forEachAxisName(function (axisName) {
            if (chartAxis[axisName] == undefined && config.options.scales[axisName] === undefined)
                return;
            if (config.options.scales[axisName] === undefined && axisName != 'r') {
                // Achse initialisieren, außer für "r"
                config.options.scales[axisName] = {
                    id: axisName,
                    //position: 'left',
                    beginAtZero: false, //true,
                    title: { display: true, text: (chartAxis[axisName] !== undefined ? chartAxis[axisName].title : 'null') },
                    gridLines: {
                        offsetGridLines: true,
                        drawOnChartArea: true,
                    },
                    stacked: chartAxis[axisName] !== undefined && chartAxis[axisName].stack !== undefined ? chartAxis[axisName].stack : false,
                    //type: chartAxis[axisName] !== undefined && chartAxis[axisName].type !== undefined ? chartAxis[axisName].type : chartType,
                    display: (axisName == 'y_alt' || !(axisName.indexOf('y') === 0 && axisName.length >= 2)), // y1, y2, y3 Achsen ausblenden //(axisName == 'y' || axisName == 'r' || axisName == chartAxis.primary || DrDocWeb.IsNullOrEmpty(chartAxis.primary)),
                    axis: axisName.indexOf('y') === 0 ? 'y' : (axisName.indexOf('r') === 0 ? 'r' : 'x'),
                };
            }
            if (config.options.scales[axisName] == undefined)
                return;
            if (axisName.indexOf('x') === 0)
                config.options.scales[axisName].position = 'bottom';

            chartAxis[axisName].distribution = 'linear';
            if (chartAxis[axisName].format == 'string') {
                config.options.scales[axisName].type = 'category';
                //config.options.scales[axisName].drawOnChartArea = false;
                config.options.scales[axisName].stackWeight = 1;
                config.options.scales[axisName].offset = false;

                let groupObjAxisName = DrDocWeb.DataGroup(data.Result, [
                    function (itm) {
                        return itm[chartAxis[axisName].fieldName];
                    }
                ]);
                console.log('groupObjAxisName data', groupObjAxisName);
                let catLabels = DrDocWeb.ObjGetKeys(groupObjAxisName);
                console.log('groupObjAxisName labels', catLabels);

                config.options.scales[axisName].labels = catLabels;

            }
            else if (chartAxis[axisName].format == 'date' || chartAxis[axisName].format == 'ttm') {
                config.options.scales[axisName].beginAtZero = false;
                config.options.scales[axisName].type = 'time';
                config.options.scales[axisName].time = {
                    parser: 'YYYY-MM-DDTHH:mm', //:ss",
                    //unit: 'year',
                    unit: 'month',
                    //min: '2015-01-01T00:00',
                    displayFormats: {
                        'millisecond': 'YYYY MMM DD',
                        'second': 'YYYY MMM DD',
                        'minute': 'YYYY MMM DD',
                        'hour': 'YYYY MMM DD',
                        'day': 'YYYY MMM DD',
                        'week': 'YYYY MMM DD',
                        'month': 'YYYY MMM DD',
                        'quarter': 'YYYY MMM DD',
                        'year': 'YYYY MMM', // DD',
                    }
                };
            }
            else
                config.options.scales[axisName].type = 'linear'; //'logarithmic';

            /*if (axisName == 'r')
            {
                config.options.scales[axisName].display = false;
                //config.options.scales[axisName].gridLines.drawOnChartArea = false;
            }*/
        });
        if (config.options.scales['y_alt'] !== undefined) {
            config.options.scales['y_alt'].position = 'right';
            //config.options.scales['y_alt'].display = false;
            //config.options.scales['y_alt'].gridLines.drawOnChartArea = false;
            //config.options.scales['y_alt'].gridLines.offsetGridLines = false;
            config.options.scales['y_alt'].gridLines = {};
        }
        if (config.options.scales['r_alt'] !== undefined) {
            config.options.scales['r_alt'].position = 'right';
            //config.options.scales['r_alt'].display = false;
            config.options.scales['r_alt'].gridLines.drawOnChartArea = false;
        }
        /*if (config.options.scales['x'] !== undefined)
        {
            config.options.scales['x'].axis = 'x';
        }*/

        //config.options.scales.x.display = chartAxis.x !== undefined;
        //config.options.scales.y.display = chartAxis.y !== undefined;
        //config.options.scales.y_alt.display = chartAxis.y_alt !== undefined;
        //config.options.scales.y3.display = chartAxis.y3 !== undefined;
        //config.options.scales.r.display = chartAxis.r !== undefined;

        if (chartType == 'radar' || chartType == 'doughnut' || chartType == 'pie') {
            forEachAxisName(function (axisName) {
                // alle Achsen entfernen/ausblenden, außer "r"
                if (config.options.scales[axisName] != undefined) {
                    config.options.scales[axisName].display = axisName.indexOf('r') === 0;
                    //delete config.options.scales[axisName];
                }
            });

            //config.options.scales.r.display = true;
            //config.options.scales.r.display = false;
            //config.options.scales.r.display = true;

            /*delete config.options.scales.x;
            delete config.options.scales.y;
            delete config.options.parsing.xAxisKey;
            delete config.options.parsing.yAxisKey;*/

            //config.options.parsing.yAxisKey = 'r';
            //config.options.parsing.rAxisKey = 'y';

            if (config.options.scales.y != undefined)
                config.options.scales.y.axis = 'r';
            if (config.options.scales.y_2 != undefined)
                config.options.scales.y_2.axis = 'r';
            //if (config.options.scales.r != undefined)
            //    config.options.scales.r.axis = 'y';
        }
        else {
            //config.options.scales.x.display = true;
            //config.options.scales.y.display = true;
            //config.options.scales.r.display = false;

            let allAxisScalableNumber = true;
            forEachAxisName(function (axisName) {
                // alle Achsen entfernen/ausblenden, außer "r"
                if (config.options.scales[axisName] != undefined) {
                    if (chartAxis[axisName].format !== 'number')
                        allAxisScalableNumber = false;
                }
            });

            if (allAxisScalableNumber) {
                config.options.plugins.quadrants = {
                    topLeft: 'rgb(255, 255, 64, 0.03)', //'rgb(255, 0, 0, 0.1)',
                    topRight: 'rgb(0, 255, 0, 0.03)',
                    bottomLeft: 'rgb(255, 0, 0, 0.03)',
                    bottomRight: 'rgb(255, 128, 64, 0.03)', //'rgb(0, 255, 0, 0.1)',
                };

                const quadrants = {
                    id: 'quadrants',
                    beforeDraw: function (chart, args, options) {
                        const { ctx, chartArea: { left, top, right, bottom }, scales: { x, y } } = chart;
                        const midX = x.getPixelForValue(0);
                        const midY = y.getPixelForValue(0);
                        ctx.save();
                        ctx.fillStyle = options.topLeft;
                        ctx.fillRect(left, top, midX - left, midY - top);
                        ctx.fillStyle = options.topRight;
                        ctx.fillRect(midX, top, right - midX, midY - top);
                        ctx.fillStyle = options.bottomRight;
                        ctx.fillRect(midX, midY, right - midX, bottom - midY);
                        ctx.fillStyle = options.bottomLeft;
                        ctx.fillRect(left, midY, midX - left, bottom - midY);
                        ctx.restore();
                    }
                };

                config.plugins.push(quadrants);
            }
        }

        console.log('Chart Scales: ', config.options.scales);

        var myChart = new Chart(
            ctx,
            config
        );

        //resolve({ data: data.Result, chart: myChart });

        if (log)
            log('Chart.js: resolve');

        return { data: data.Result, chart: myChart };
    }; // processResponse Ende

    if (retAsync === true) {
        if (log)
            log('Chart.js: proc resp 1: Async');

        return DrDocWeb.Send('GET', getDataUrl, getObj, undefined, 'json', '', cookie, retAsync === true).then(processResponse);
    }
    else {
        if (log)
            log('Chart.js: proc resp 1: Synchronous');

        let data = DrDocWeb.Send('GET', getDataUrl, getObj, undefined, 'json', '', cookie, retAsync === true);

        if (log)
            log('Chart.js: proc resp 2: Synchronous');

        return processResponse(data);
    }
    //}); // DrDocWeb.Send then ENDE

    //}); // Promise ENDE
};

//module.exports = DrDocChart
//export default DrDocChart;
window.DrDocChart = DrDocChart;
